import React, { useState, useEffect, useRef } from 'react';
import { Chart } from '@antv/g2';
import './index.less';

export interface HeadProps {
  data: any[],
  noPercent?: boolean,
  color?: string[],
  onDataUrl?: (chart: any) => void,
  direction?: 'vertical' | 'horizontal',
  reflect?: 'y' | 'x'
}

const ColumnChart = (props: HeadProps) => {
  const { data, color, noPercent, direction, reflect, onDataUrl } = props;
  const divRef: React.RefObject<HTMLDivElement> = useRef(null)
  const [columnChart, setChart] = useState<any>(null);

  useEffect(() => {
    if (!divRef.current) {
      return
    }
    if (columnChart) {
      columnChart.destroy()
    }

    let padding = [20, 0, 20, 40]
    if (direction === 'horizontal') {
      padding = [0, 50, 20, 50]
    }
    const chart = new Chart({
      container: divRef.current,
      autoFit: true,
      // height: 296,
      padding,
    });

    chart.data(data);
    chart.scale('value', {
      nice: true,
    });

    let coordinate: any = null
    if (direction === 'horizontal') {
      coordinate = chart.coordinate().transpose()
    } else {
      coordinate = chart.coordinate()
    }

    if (reflect) {
      coordinate.reflect(reflect);
    }

    chart.axis('value', {
      label: {
        autoHide: false,
        autoEllipsis: false,
        style: {
          fontSize: 14
        },
        formatter: text => {
          return `${text}${noPercent ? '' : '%'}`;
        }
      }
    });
    chart.axis('label', {
      label: {
        style: {
          fontSize: 10
        },
        // rotate: Math.PI / 180 * -25,
        autoHide: false,
        autoEllipsis: false,
      }
    });

    chart.tooltip({
      showCrosshairs: false,
      shared: true,
      customItems: (items) => {
        return items.map((item) => {
          return {
            ...item,
            value: `${item.value}${noPercent ? '' : '%'}`
          }
        })
      },
    });

    chart.legend(false)

    const style: any = {
      fontSize: 14
    }
    if (color && color[0]) {
      style.fill = color[0]
    }
    chart.interval().position('label*value').color('label', color).label('value', {
      style,
      content: (data) => {
        return `${data.value}${noPercent ? '' : '%'}`;
      },
    });
    chart.interaction('active-region');

    chart.render();
    setChart(chart)
  }, [data, color, noPercent, direction, reflect, divRef.current]);

  useEffect(() => {
    if (columnChart && typeof onDataUrl === 'function') {
      setTimeout(() => {
        onDataUrl(columnChart)
      }, 1000)
    }
  }, [onDataUrl, columnChart])

  return (
    <div ref={divRef} style={{ width: 594, height: 300 }}></div>
  );
};

export default React.memo(ColumnChart);
